module.exports = __webpack_public_path__ + "img/gds_logo.8507a99a.png";